import { PreAuthApiHandler, PostAuthApiHandler } from "@rakbank/rak-authenticator";
import {
  AUTH_API_KEY,
  AUTH_CLIENT_ID,
  AUTH_RESOURCE_TYPE,
  AGENT_AUTH_RESOURCE_TYPE,
  AUTH_CLIENT_SECRET
} from "../constants";
import { deviceId } from "./deviceId";

const isAgentUrl =
  window?.location?.href.includes("agent/") ||
  window?.location?.href.includes("business/SearchItemRedirect");
const resourceType = isAgentUrl ? AGENT_AUTH_RESOURCE_TYPE : AUTH_RESOURCE_TYPE;

export const PreAuthInstance = new PreAuthApiHandler({
  client_id: AUTH_CLIENT_ID,
  resource_type: resourceType,
  client_secret: AUTH_CLIENT_SECRET,
  device_id: deviceId,
  apiKey: AUTH_API_KEY,
  baseUrl: process.env.REACT_APP_API_PATH
}).createInstance();

export const PostAuthInstance = new PostAuthApiHandler({
  client_id: AUTH_CLIENT_ID,
  resource_type: resourceType,
  client_secret: AUTH_CLIENT_SECRET,
  device_id: deviceId,
  apiKey: AUTH_API_KEY,
  baseUrl: process.env.REACT_APP_API_PATH
}).createInstance();
